import type { NativeEmbedFeature } from '@atlassian/native-embeds-core/types';
import type { ActionContext } from '@atlassian/native-embeds-core/types/action-context';

/**
 * Resolves `true` once the host and child agree on `feature` and the host can deliver the child's
 * replies. Kept apart from the channel so the eager loader can check without loading the channel.
 */
export function waitForChannelFeature(
	context: ActionContext,
	feature: NativeEmbedFeature,
): Promise<boolean> {
	if (!context.supportedFeatures || !context.onChildCommand) {
		return Promise.resolve(false);
	}
	return context.supportedFeatures.then((features) => features.has(feature));
}
